var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('h1',[_vm._v("Template Title Here")]),_c('b-card',{staticClass:"rounded-lg",attrs:{"footer-class":"p-0"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }